// extracted by mini-css-extract-plugin
module.exports = {"root":"AcceptCookies_root__2Sy6g","content":"AcceptCookies_content__25b0N","actions":"AcceptCookies_actions__WwxHl"};